import styled from "@emotion/styled";

export const MetadataTitleBlock = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-bottom: 5px;
`;

export const MetadataTitle = styled.div`
    text-align: center;
    color: #fff;
    font-weight: bold;
    font-size: 1rem;
`;

export const MetadataSubTitle = styled.div`
    text-align: center;
    margin-bottom: 14px;
    color: #d57100;
    font-style: italic;
    font-size: 0.8rem;
`;

export const FormContainer = styled.div`
    width: 100%;
    margin: 0 auto;
`;

export const FormTitle = styled.h2`
    text-align: center;
    margin-bottom: 20px;
`;

export const FormWrapper = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 20px;

    @media (min-width: 900px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
`;

export const GridItem = styled.div`
    min-width: 0;
    grid-column: ${({ $full }) => ($full ? "1 / -1" : "auto")};

    > * {
        width: 100%;
        min-width: 0;
    }
`;

export const OptionalSection = styled.div`
    display: grid;
    gap: 18px;
    padding: 20px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.03);

    > div + div {
        padding-top: 18px;
        border-top: 1px solid rgba(255, 255, 255, 0.08);
    }
`;

export const OptionalFieldWrap = styled.div`
    padding-top: 12px;
    padding-left: 52px;

    @media (max-width: 899px) {
        padding-left: 0;
    }
`;

export const FormGroup = styled.div`
    flex: 1;
    min-width: 200px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const FormLabel = styled.label`
    color: #fff;
    margin-bottom: 0px;
`;

export const FormError = styled.p`
    color: #ff4d4d;
    margin-bottom: -5px;
`;

export const Input = styled.input`
    width: 100%;
    padding: 5px;
    margin-top: 5px;
    border-radius: 3px;
    background-color: #f0f0f0;
`;

export const Select = styled.select`
    width: 100%;
    padding: 5px;
    margin-top: 5px;
    border-radius: 3px;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    font-size: ${({ theme }) => theme.fontSizes.medium};
    box-sizing: border-box;
    appearance: none;
    background-size: 12px;
    appearance: auto;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(38, 143, 255, 0.25);
    }
`;

export const Option = styled.option``;

export const CustomDatePickerInput = styled.input`
    padding: 5px;
    border-radius: 3px;
    width: 100%;
    background-color: #f0f0f0;
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 5px;
  margin-top: 5px;
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 3px;
`;

export const DatePickerWrapper = styled.div`
  width: 100%;
  margin-top: 5px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

export const ActionsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 24px;

  @media (max-width: 899px) {
    flex-direction: column-reverse;
    align-items: stretch;

    > button {
      width: 100%;
    }
  }
`;

export const FormButton = styled.button`
  background-color: ${(props) => (props.buttonState === "previous" ? "#ccc" : "#007bff")};
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;

  &:disabled {
    background-color: #e0e0e0;
    cursor: not-allowed;
  }
`;